/**
 * Arabic translations for registration wizard.
 */

const registration = {
  // Page header
  title: 'التسجيل',
  subtitle: 'إنشاء حساب صفقات 24',

  // User type selection
  userType: {
    title: 'بأي صفة تريد التسجيل؟',
    subtitle: 'اختر ما يناسبك - اعرض عقارك كفرد، أو سجّل كوسيط عقاري مرخّص أو كشركة عقارية.',
    individual: {
      title: 'فرد',
      description: 'أعرض عقارك للبيع أو الإيجار عبر صفقات 24',
    },
    broker: {
      title: 'مسوّق ووسيط عقاري',
      description: 'متخصص عقاري برخصة فال',
    },
    company: {
      title: 'شركة',
      description: 'شركة عقارية برخصة فال وسجل تجاري',
    },
    developer: {
      title: 'مطوّر عقاري',
      description: 'مطوّر يعرض المشاريع والمجمعات، برخصة فال',
    },
  },

  // Step labels
  steps: {
    userType: 'نوع الحساب',
    account: 'الحساب',
    emailVerify: 'تحقق من البريد',
    businessInfo: 'معلومات العمل',
    propertyInfo: 'معلومات العقار',
    contact: 'التواصل',
    subscription: 'الاشتراك',
    payment: 'الدفع',
    review: 'المراجعة',
  },

  // Email verification step
  emailVerify: {
    title: 'تحقق من بريدك الإلكتروني',
    subtitle: 'أرسلنا رمزًا مكونًا من 6 أرقام إلى',
    enterCode: 'أدخل رمز التحقق',
    verify: 'تحقق',
    resend: 'إعادة إرسال الرمز',
    resendIn: 'إعادة الإرسال خلال {{seconds}} ثانية',
    codeSent: 'تم إرسال رمز التحقق!',
    invalidCode: 'رمز غير صالح. يرجى المحاولة مرة أخرى.',
    codeExpired: 'انتهت صلاحية الرمز. يرجى إعادة الإرسال.',
    differentEmail: 'استخدم بريد إلكتروني آخر',
  },

  // Account creation
  account: {
    title: 'إنشاء حسابك',
    subtitle: 'أدخل بياناتك للبدء',
    // بيانات اختيارية (منصة الإحصائيات)
    gender: 'الجنس',
    genderSelect: 'اختر (اختياري)',
    genderMale: 'ذكر',
    genderFemale: 'أنثى',
    genderUndisclosed: 'أفضّل عدم الإفصاح',
    nationality: 'الجنسية',
    nationalitySelect: 'اختر (اختياري)',
    birthYear: 'سنة الميلاد',
    birthYearSelect: 'اختر (اختياري)',
    demographicsNote: 'اختياري - يساعدنا على فهم جمهورنا. يمكنك تغييره أو إزالته في أي وقت من إعدادات حسابك.',
    firstName: 'الاسم الأول',
    firstNamePlaceholder: 'محمد',
    lastName: 'الاسم الأخير',
    lastNamePlaceholder: 'أحمد',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'you@example.com',
    phone: 'رقم الجوال',
    phonePlaceholder: '+966 5XX XXX XXXX',
    password: 'كلمة المرور',
    passwordPlaceholder: '8 أحرف على الأقل',
    confirmPassword: 'تأكيد كلمة المرور',
    confirmPasswordPlaceholder: 'أعد إدخال كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    errors: {
      firstNameRequired: 'الاسم الأول مطلوب',
      lastNameRequired: 'الاسم الأخير مطلوب',
      emailRequired: 'البريد الإلكتروني مطلوب',
      emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
      phoneRequired: 'رقم الجوال مطلوب',
      phoneInvalid: 'يرجى إدخال رقم جوال صحيح',
      passwordRequired: 'كلمة المرور مطلوبة',
      passwordLength: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
      confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
      passwordMismatch: 'كلمتا المرور غير متطابقتين',
    },
  },

  // Business info form
  businessInfo: {
    title: 'معلومات العمل',
    subtitle: 'أخبرنا عن عملك',
    companyName: 'اسم الشركة',
    companyNameAr: 'اسم الشركة (بالعربية)',
    companyNamePlaceholder: 'أدخل اسم الشركة',
    crNumber: 'السجل التجاري',
    crNumberPlaceholder: 'أدخل رقم السجل التجاري',
    crNumberHelp: 'رقم من 10 خانات من وزارة التجارة',
    falLicense: 'رقم رخصة فال',
    falLicensePlaceholder: 'أدخل رقم رخصة فال',
    falLicenseHelp: 'مطلوب لممارسة الأنشطة العقارية في المملكة',
    phone: 'رقم الهاتف',
    phonePlaceholder: '05xxxxxxxx',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'contact@company.com',
    address: 'عنوان العمل',
    city: 'المدينة',
    cityPlaceholder: 'اختر المدينة',
    district: 'الحي',
    districtPlaceholder: 'أدخل اسم الحي',
    fullAddress: 'العنوان التفصيلي',
    fullAddressPlaceholder: 'اسم الشارع، رقم المبنى...',
    logo: 'شعار الشركة',
    logoHelp: 'ارفع شعار شركتك (PNG، JPG، حد أقصى 5MB)',
    uploadLogo: 'رفع الشعار',
    changeLogo: 'تغيير الشعار',
    removeLogo: 'حذف',
  },

  // Subscription selection
  subscription: {
    title: 'اختر باقتك',
    subtitle: 'اختر الباقة المناسبة لاحتياجاتك',
    monthly: 'شهري',
    yearly: 'سنوي',
    yearlyDiscount: 'وفر {{percent}}%',
    perMonth: '/شهر',
    perYear: '/سنة',
    mostPopular: 'الأكثر شيوعاً',
    features: {
      listings: '{{count}} إعلان',
      teamMembers: '{{count}} عضو فريق',
      featuredListings: '{{count}} إعلان مميز',
      prioritySupport: 'دعم أولوية',
      analytics: 'تحليلات متقدمة',
      apiAccess: 'وصول API',
    },
    selectPlan: 'اختر الباقة',
    selected: 'تم الاختيار',
    currentPlan: 'الباقة الحالية',
    skipForNow: 'تخطي الآن',
    skipNote: 'يمكنك اختيار خطة لاحقًا من صفحة الاشتراكات',
  },

  // Promo code
  promo: {
    title: 'كود الخصم',
    placeholder: 'أدخل كود الخصم',
    apply: 'تطبيق',
    applying: 'جاري التطبيق...',
    remove: 'إزالة',
    valid: 'تم تطبيق كود الخصم!',
    invalid: 'كود خصم غير صالح',
    expired: 'انتهت صلاحية هذا الكود',
    limitReached: 'وصل هذا الكود للحد الأقصى من الاستخدام',
    discount: 'الخصم: {{amount}} ريال',
    percentOff: 'خصم {{percent}}%',
    freeMonths: '{{count}} شهر مجاناً',
  },

  // Payment
  payment: {
    title: 'الدفع',
    subtitle: 'أكمل اشتراكك',
    summary: 'ملخص الطلب',
    plan: 'الباقة',
    billing: 'الفوترة',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    total: 'الإجمالي',
    securePayment: 'دفع آمن عبر Moyasar',
    methods: {
      cards: 'بطاقات',
      mada: 'مدى',
      applePay: 'Apple Pay',
    },
    processing: 'جاري معالجة الدفع...',
    success: 'تم الدفع بنجاح!',
    failed: 'فشل الدفع',
    tryAgain: 'حاول مرة أخرى',
  },

  // Review step
  review: {
    title: 'المراجعة والتأكيد',
    subtitle: 'يرجى مراجعة معلوماتك',
    businessDetails: 'تفاصيل العمل',
    subscriptionDetails: 'تفاصيل الاشتراك',
    paymentDetails: 'تفاصيل الدفع',
    edit: 'تعديل',
    confirm: 'تأكيد وإرسال',
    submitting: 'جاري الإرسال...',
    termsText: 'بالنقر على تأكيد، فإنك توافق على',
    termsLink: 'شروط الخدمة',
    andText: 'و',
    privacyLink: 'سياسة الخصوصية',
  },

  // FAL Disclaimer
  fal: {
    title: 'إخلاء مسؤولية رخصة فال',
    subtitle: 'معلومات مهمة عن إدراج عقارك',
    body1: 'سيتم إدراج عقارك تحت رخصة فال العقارية الخاصة بصفقات 24 والصادرة عن الهيئة العامة للعقار. تعمل صفقات 24 كوسيط تسهيلي بينك وبين المشترين أو المستأجرين المحتملين.',
    body2: 'ستطبق عمولة 2.5% (بالإضافة إلى ضريبة القيمة المضافة 15%) على المعاملات الناجحة. أنت تحتفظ بكامل حقوق الملكية طوال العملية بأكملها.',
    body3: 'بعد الموافقة، سيتم الإعلان عن عقارك تحت اعتماد فال الخاص بصفقات 24 وسيظهر رقم ترخيص إعلاني ساري المفعول، وفقاً لمتطلبات الهيئة العامة للعقار.',
    howItWorks: 'كيف يعمل',
    step1: 'قدم تفاصيل عقارك من خلال نموذجنا',
    step2: 'يراجع فريقنا ويوافق على إعلانك',
    step3: 'يتم إدراج العقار على صفقات 24 تحت رخصة فال الخاصة بنا',
    step4: 'نتولى الاستفسارات ونسهل المعاملة',
    checkbox: 'أفهم وأوافق على إدراج عقاري تحت رخصة فال الخاصة بصفقات 24',
    continue: 'متابعة إلى نموذج العقار',
    back: 'رجوع',
  },

  // Individual flow
  individual: {
    title: 'أعرض عقارك',
    subtitle: 'قدم عقارك ليتم إدراجه بواسطة صفقات 24',
    propertyType: 'نوع العقار',
    propertyTypePlaceholder: 'اختر نوع العقار',
    listingType: 'نوع الإعلان',
    forSale: 'للبيع',
    forRent: 'للإيجار',
    description: 'وصف العقار',
    descriptionPlaceholder: 'صف عقارك...',
    descriptionHelp: 'أضف تفاصيل عن الغرف ودورات المياه والمساحة والميزات',
    expectedPrice: 'السعر المتوقع',
    expectedPricePlaceholder: 'أدخل السعر المتوقع بالريال',
    location: 'موقع العقار',
    contact: 'معلومات التواصل',
    contactName: 'الاسم',
    contactPhone: 'رقم الهاتف',
    contactEmail: 'البريد الإلكتروني (اختياري)',
    howItWorks: 'كيف يعمل',
    step1: 'قدم تفاصيل عقارك',
    step2: 'فريقنا يراجع ويتواصل معك',
    step3: 'يتم إدراج العقار تحت رخصة فال صفقات 24',
    step4: 'ادفع العمولة فقط عند نجاح البيع/الإيجار',
    commission: 'العمولة: {{rate}}% (بالإضافة إلى ضريبة القيمة المضافة 15%) على المعاملة الناجحة',
  },

  // Success screens
  success: {
    title: 'مرحباً بك في صفقات 24!',
    subtitle: 'اكتمل تسجيلك بنجاح',
    accountCreated: 'تم إنشاء الحساب',
    companyCreated: 'تم إنشاء الشركة',
    profileCreated: 'تم إنشاء الملف الشخصي',
    subscriptionActive: 'الاشتراك نشط',
    whatNext: 'ما التالي؟',
    completeProfile: 'أكمل ملفك الشخصي',
    inviteTeam: 'ادعُ أعضاء الفريق',
    addListing: 'أضف إعلانك الأول',
    goDashboard: 'الذهاب للوحة التحكم',
    skipOnboarding: 'تخطي الآن',
  },

  individualSuccess: {
    title: 'تم إنشاء حسابك بنجاح!',
    subtitle: 'يمكنك الآن إدراج عقارك على صفقات 24',
    requestId: 'رقم الطلب',
    status: 'الحالة',
    pending: 'قيد المراجعة',
    nextSteps: 'ماذا سيحدث بعد ذلك؟',
    step1: 'اضغط "أدرج عقارك" لتقديم تفاصيل عقارك',
    step2: 'اقبل إخلاء المسؤولية الخاص برخصة فال',
    step3: 'املأ معلومات العقار وقدمه للمراجعة',
    trackStatus: 'تتبع طلبك',
    listProperty: 'أدرج عقارك',
    goHome: 'الذهاب للرئيسية',
  },

  // Validation messages
  validation: {
    required: 'هذا الحقل مطلوب',
    invalidEmail: 'يرجى إدخال بريد إلكتروني صحيح',
    invalidPhone: 'يرجى إدخال رقم هاتف صحيح',
    invalidCR: 'يرجى إدخال رقم سجل تجاري صحيح',
    invalidFAL: 'يرجى إدخال رقم رخصة فال صحيح',
    selectPlan: 'يرجى اختيار باقة اشتراك',
    selectType: 'يرجى اختيار نوع العقار',
    selectListingType: 'يرجى اختيار بيع أو إيجار',
    minDescription: 'يجب أن يكون الوصف 50 حرفاً على الأقل',
  },

  // Action buttons
  buttons: {
    continue: 'متابعة',
    back: 'رجوع',
    submit: 'إرسال',
    cancel: 'إلغاء',
    saveDraft: 'حفظ والخروج',
    loading: 'جاري التحميل…',
  },

  // Draft recovery
  draft: {
    found: 'متابعة من حيث توقفت؟',
    continue: 'متابعة التسجيل',
    startOver: 'البدء من جديد',
  },

  // Individual property request page
  individualRequest: {
    pageTitle: 'تقديم طلب عقار',
    pageSubtitle: 'املأ تفاصيل عقارك وسنقوم بإدراجه تحت رخصة فال الخاصة بصفقات 24',
    submitSuccess: 'تم تقديم طلب عقارك بنجاح! سيقوم فريقنا بمراجعته قريباً.',
    submitError: 'فشل تقديم طلبك. يرجى المحاولة مرة أخرى.',
    submitting: 'جاري تقديم طلبك...',
  },

  // Navigation
  navigation: {
    back: 'رجوع',
    continue: 'متابعة',
    submit: 'إرسال الطلب',
  },

  // FAL status display in account/profile settings
  falStatus: {
    title: 'التحقق من ترخيص الفال',
    verified: 'تم التحقق من ترخيص الفال الخاص بك',
    pending: 'ترخيص الفال قيد المراجعة',
    pendingNote: 'سيتم إعلامك عند التحقق منه',
    rejected: 'تم رفض ترخيص الفال الخاص بك',
    rejectionReason: 'السبب',
    licenseNumber: 'رقم ترخيص الفال',
    crNumber: 'رقم السجل التجاري',
    resubmit: 'إعادة التقديم للمراجعة',
    resubmitSuccess: 'تم إعادة تقديم ترخيص الفال للمراجعة',
    updateLicense: 'تحديث رقم الترخيص',
    submitting: 'جاري الإرسال...',
    submitError: 'فشل الإرسال. يرجى المحاولة مرة أخرى.',
  },

  // التسجيل حسب الهدف (components/registration/intent/IntentSignupFlow.tsx):
  // اسم خيار المسوّق، ومؤشر الخطوات فوق كل شاشة.
  intent: {
    marketer: 'مسوّق ووسيط عقاري',
    stepperLabel: 'خطوات إنشاء الحساب',
    steps: {
      intent: 'نوع الحساب',
      roles: 'النشاط',
      company: 'بيانات الشركة',
      account: 'بياناتك',
      verify: 'تأكيد البريد',
      pro: 'التوثيق المهني',
    },
  },
};

export default registration;
